import axios from "axios";

// With Nginx handling the proxy, we can use relative URLs
// This falls back to absolute URL for development environments
const API_BASE_URL = process.env.NODE_ENV === "production" ? "" : process.env.REACT_APP_API_URL || "http://localhost:8000";

export const requestDemo = async (formData) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/api/demo`, {
      fullName: formData.fullName,
      company: formData.company,
      email: formData.email,
      phoneNumber: formData.phoneNumber,
      modules: {
        module_universal_adapters: formData.modules?.module_universal_adapters || false,
        module_blox_blueprint: formData.modules?.module_blox_blueprint || false,
        module_bpsc_compiler: formData.modules?.module_bpsc_compiler || false,
        module_frontier_blox_engine: formData.modules?.module_frontier_blox_engine || false,
      },
      message: formData.message || "",
    });

    return response.data;
  } catch (error) {
    if (error.response) {
      // The server responded with a status code outside the 2xx range
      throw new Error(error.response.data.error || "Failed to submit demo request");
    } else if (error.request) {
      // The request was made but no response was received
      throw new Error("No response from server. Please try again later.");
    } else {
      // Something happened in setting up the request
      throw new Error("Error setting up request. Please try again.");
    }
  }
};
